import constants from "../constants";

const {
  GET_ALL_CHAT_MESSAGES,
  UPDATE_CHAT_STORE,
  SEND_CHAT_MESSAGE,
  SEND_CHAT_READ_EVENT,
  ADD_CHAT_MESSAGE_STORE,
  DELETE_CHAT_MESSAGE,
} = constants;

export const getAllChatMessages = () => ({
  type: GET_ALL_CHAT_MESSAGES,
});

export const updateChatStore = (data) => ({
  type: UPDATE_CHAT_STORE,
  data,
});

export const sendChatMessage = (data) => ({
  type: SEND_CHAT_MESSAGE,
  data,
});

export const sendChatReadEvent = (data) => ({
  type: SEND_CHAT_READ_EVENT,
  data,
});

export const addChatMessageStore = ({ clientReservationId, message }) => ({
  type: ADD_CHAT_MESSAGE_STORE,
  data: { clientReservationId, message },
});

export const deleteChatMessage = (data) => ({
  type: DELETE_CHAT_MESSAGE,
  data,
});
